import { render, staticRenderFns } from "./MicrophoneTest.vue?vue&type=template&id=3d92be94"
import script from "./MicrophoneTest.vue?vue&type=script&lang=js"
export * from "./MicrophoneTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports